/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Dropdown filter button for cashback account selector
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import DropDownFilterButtonCommon, { IDropDownFilterButtonProps } from '../../../components/common/DropDownFilter/DropDownFilterButtonCommon';
import { IPageCashbackTranslation } from '../../../modules/internationalization/types/pages/cashback';
import { fonts } from '../../../theme';
import { CashbackAccountSelectDropDownFilterButtonStyled } from './styled/CashbackControlStyled';
import { CashbackTextStyled } from './styled/CashbackStyled';

export interface ICashbackAccountSelectDropDownFilterButton extends IDropDownFilterButtonProps {
    translationCashback: IPageCashbackTranslation;
}

const CashbackAccountSelectDropDownFilterButton = (props: ICashbackAccountSelectDropDownFilterButton) => (
    <CashbackAccountSelectDropDownFilterButtonStyled>
        <CashbackTextStyled font={fonts.textSmall}>
            {props.translationCashback.account}
        </CashbackTextStyled>
        <DropDownFilterButtonCommon {...props} />
    </CashbackAccountSelectDropDownFilterButtonStyled>
);


export default CashbackAccountSelectDropDownFilterButton;
